import script from "./RecommendSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendSelect.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__